import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Services from './pages/Services';
import Company from './pages/Company';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import Admin from './pages/admin/Admin';
import Client from './pages/client/Client';
import apiService from './services/api';

const AppContent: React.FC = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isClientRoute = location.pathname.startsWith('/cliente');
  const showPublicLayout = !isAdminRoute && !isClientRoute;
  const isAuthenticationPage = ['/login', '/register', '/registro'].includes(location.pathname);

  React.useEffect(() => {
    if (!isLoading && !user && showPublicLayout && !isAuthenticationPage) {
      apiService.trackAnalytics('page_view', location.pathname).catch(() => undefined);
    }
  }, [isAuthenticationPage, isLoading, location.pathname, showPublicLayout, user]);

  const selectInitialNumericZero = (event: React.FocusEvent<HTMLDivElement>) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    const isNumeric = input.type === 'number' || input.inputMode === 'decimal' || input.inputMode === 'numeric';
    if (isNumeric && input.value.trim() !== '' && Number(input.value.replace(',', '.')) === 0) {
      input.select();
    }
  };
  return (
    <div className="min-h-screen flex flex-col" onFocusCapture={selectInitialNumericZero}>
      {showPublicLayout && <Navbar />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/productos" element={<Products />} />
          <Route path="/productos/:id" element={<ProductDetail />} />
          <Route path="/servicios" element={<Services />} />
          <Route path="/empresa" element={<Company />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/cliente/*" element={<Client />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {showPublicLayout && <Footer />}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
